import React from 'react';

const caseStudyLogo = require('images/admin/campaign_wrap_up/repurpose/repurpose-case-study.png');
const mainImg = require('images/admin/campaign_wrap_up/repurpose/repurpose-main.png');

function RepurposeSuggestions(props) {
    const {bgColor, renderForPdf, getAssetPath} = props;

    return (
        <div className="repurpose-suggestions wrap-up-section">
            <div className="repurpose-suggestions-header">
                <div className="repurpose-suggestions-header-title">
                    <div id="amplification-title">AMPLIFICATION</div>
                    <div id="amplification-subtitle">CASE STUDY</div>
                </div>
                <div className="repurpose-suggestions-header-logo" />
            </div>
            <div className="repurpose-suggestions-subtitle">
                <div className="repurpose-suggestions-subtitle-text">
                    Polaroid saw a <b>180% increase</b> in sales when they launched consumer
                    generated content across brand marketing channels
                </div>
            </div>
            <div className="repurpose-suggestions-body">
                <div className="case-study">
                    <div className="case-study-story">
                        <div className="case-study-title">The Story</div>
                        <div className="case-study-body">
                            {
                                "Polaroid's goal was to replace white background product images with content created by their consumers with Polaroid cameras to increase product affinity and drive online sales."
                            }
                        </div>
                    </div>
                    <div className="case-study-ask">
                        <div className="case-study-title">The Ask</div>
                        <div className="case-study-body">
                            {
                                'Polaroid targeted individual consumers and asked them to create custom content that illustrates their love for the Polaroid product & the quality of images created via the camera.'
                            }
                        </div>
                    </div>
                    <div className="case-study-result">
                        <div className="case-study-title">The Result</div>
                        <div className="case-study-body">
                            {
                                'Over the course of 2016, Polaroid created 1,000 unique, consumer generated images and videos. The brand increased paid CTR by 213% and increased online sales by 180%.'
                            }
                        </div>
                    </div>
                </div>
                <img className="case-study-img" src={getAssetPath(mainImg)} />
            </div>

            {/*STYLES*/}

            <style>{`
    .repurpose-suggestions {
    background-color: ${bgColor};
    padding: 0px 20px 60px 20px;
    }

    .repurpose-suggestions-header {
    padding: 40px 0px;
    width: 100%;
    max-width: 1200px;
    }

    .repurpose-suggestions-header-title {
    font-size: 36px;
    }

    #amplification-title {
    font-weight: bold;
    }

    #amplification-subtitle {
    font-weight: 200;
    }

    .repurpose-suggestions-header-logo {
    background-image: url(${getAssetPath(caseStudyLogo)});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    height: 100px;
    width: 160px;
    }

    .repurpose-suggestions-subtitle {
    font-size: 26px;
    font-weight: 200;
    width: 100%;
    max-width: 1200px;
    padding-bottom: 20px;
    }

    .repurpose-suggestions-subtitle-text {
    width: 70%;
    }

    .repurpose-suggestions-body {
    width: 100%;
    max-width: 1200px;
    }

    .case-study {
    width: 390px;
    }

    .case-study-title {
    font-size: 22px;
    font-weight: bold;
    }

    .case-study-body {
    font-size: 20px;
    font-weight: 200;
    }

    .case-study-story {
    padding-bottom: 40px;
    }

    .case-study-ask {
    padding-bottom: 40px;
    }

    .case-study-img {
    height: 850px;
    width: 550px;
    margin: 20px 0px;
    }

    @media (max-width: 1120px) {
    .repurpose-suggestions-body {
    justify-content: center;
    align-items: center;
    }

    .case-study {
    width: 100%;
    }

    .case-study-img {
    height: 750px;
    width: 500px;
    margin: 40px 0px 20px 0px;
    }
    }
    `}</style>

            {/*STYLE FOR WEB*/}
            {!renderForPdf ? (
                <style>{`
    .repurpose-suggestions {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    }

    .repurpose-suggestions-header {
    display: flex;
    justify-content: space-between;
    }

    .repurpose-suggestions-body {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    }
    `}</style>
            ) : null}

            {/*STYLE FOR PDF*/}
            {renderForPdf ? (
                <style>{`
    .repurpose-suggestions {
    position: relative;
    padding-top: 20px;
    background-color: #FFF;
    }

    .repurpose-suggestions-header {
    }

    .repurpose-suggestions-header-title {
    display: inline-block;
    vertical-align: top;
    }

    .repurpose-suggestions-header-logo {
    position: absolute;
    top: 48;
    right: 0;
    }

    .repurpose-suggestions-body {
    }

    .case-study {
    display: inline-block;
    vertical-align: middle;
    width: 40%;
    padding-right: 5%;
    padding-top: 120px;
    }

    .case-study-img {
    display: inline-block;
    vertical-align: top;
    }
    `}</style>
            ) : null}
        </div>
    );
}

export default RepurposeSuggestions;



// WEBPACK FOOTER //
// ./campaign_analytics/campaign_wrap_up/repurpose_suggestions/index.js